import React from "react";
import "./Services.css";

const Services = () => {
  return (
    <main className="services-page">

      <section className="services-hero">

        <p className="services-eyebrow">
          WHAT WE DO
        </p>

        <h1>
          Digital Services That
          <span> Drive Growth</span>
        </h1>

        <p>
          We help businesses generate leads, increase visibility,
          build powerful websites, and grow through modern digital
          marketing strategies.
        </p>

      </section>


      <section className="services-grid">

        <div className="service-page-card" id="google-search-ads">
          <h2>Google Search Ads</h2>
          <p>
            High-intent Google Search campaigns designed to generate
            qualified leads and maximize your advertising budget.
          </p>
        </div>


        <div className="service-page-card" id="seo">
          <h2>SEO</h2>
          <p>
            Improve your search visibility, organic traffic, and
            rankings with a strategic SEO approach.
          </p>
        </div>


        <div className="service-page-card" id="local-services-ads">
          <h2>Local Services Ads</h2>
          <p>
            Get your local business in front of customers actively
            searching for your services.
          </p>
        </div>


        <div className="service-page-card" id="meta-lead-ads">
          <h2>Meta Lead Ads</h2>
          <p>
            Generate targeted leads through highly optimized
            Facebook and Instagram advertising campaigns.
          </p>
        </div>


        <div className="service-page-card" id="web-development">
          <h2>Web Development</h2>
          <p>
            Build fast, responsive, modern websites designed to
            convert visitors into customers.
          </p>
        </div>


        <div className="service-page-card" id="ai-video-creation">
          <h2>AI Video Creation</h2>
          <p>
            Create engaging AI-powered video content for marketing,
            advertising, and social media.
          </p>
        </div>

      </section>

    </main>
  );
};

export default Services;